import { WizAuthority } from "@/containers/common";

export default columns = (initialValue) => [
  {
    title: "管理权限",
    name: "authCmd",
    formItem: {
      type: "diy",
      diy: WizAuthority,
      initialValue,
      keys: ["orgIds", "positionIds", "positionCategoryIds", "personIds", "isAll"]
    },
  }
]